const useReportWizardConfig = () => {
  const steps = [
    {
      id: "features",
    },
    {
      id: "conclusions",
    },
    {
      id: "report_preview",
    },
  ];
  return { steps };
};

export default useReportWizardConfig;
